import FourPlayersIntroduction from './fourPlayersIntroduction'

export default FourPlayersIntroduction